/* src/app/indirect-rate/indirect-rate-review/indirect-rate-review-presenter/indirect-rate-review-presenter.component.scss */
body#themeTag :host ::ng-deep .rate-review-table .p-datatable-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
body#themeTag :host ::ng-deep div.p-message {
  margin: 0;
  padding: 0;
}
body#themeTag :host ::ng-deep div.p-message div.p-message-wrapper {
  padding: 0 0.5em 0 0.5em;
}
/*# sourceMappingURL=indirect-rate-review-presenter.component.css.map */
